import { defineComponent as _defineComponent } from 'vue'
import { unref as _unref, toDisplayString as _toDisplayString, createElementVNode as _createElementVNode, resolveComponent as _resolveComponent, createVNode as _createVNode, withCtx as _withCtx, openBlock as _openBlock, createBlock as _createBlock, createCommentVNode as _createCommentVNode, createElementBlock as _createElementBlock, createTextVNode as _createTextVNode, renderList as _renderList, Fragment as _Fragment, pushScopeId as _pushScopeId, popScopeId as _popScopeId } from "vue"

const _withScopeId = n => (_pushScopeId("data-v-64ae532b"),n=n(),_popScopeId(),n)
const _hoisted_1 = { key: 0 }
const _hoisted_2 = { class: "mb-3 mb-md-4 pb-1" }
const _hoisted_3 = { key: 1 }
const _hoisted_4 = { class: "mb-3 mb-md-4 pb-1" }
const _hoisted_5 = { class: "mt-4 mt-sm-5 mb-3 row flex-wrap justify-content-end gy-2" }
const _hoisted_6 = { class: "col-auto" }
const _hoisted_7 = {
  key: 0,
  class: "mb-0 mt-2 h2"
}
const _hoisted_8 = { class: "col-12 profile-form py-3 py-lg-5" }
const _hoisted_9 = { class: "row d-flex flex-wrap" }
const _hoisted_10 = /*#__PURE__*/ _withScopeId(() => /*#__PURE__*/_createElementVNode("div", { class: "line-title mb-4 mb-sm-5" }, [
  /*#__PURE__*/_createTextVNode(" General  "),
  /*#__PURE__*/_createElementVNode("div", {
    style: {"white-space":"nowrap"},
    class: "d-flex align-items-center col"
  }, [
    /*#__PURE__*/_createTextVNode(" Information "),
    /*#__PURE__*/_createElementVNode("div", { class: "line-visual" })
  ])
], -1))
const _hoisted_11 = { class: "mimic-input text-truncate col-12 mb-2" }
const _hoisted_12 = { class: "mimic-input text-truncate col-12 mb-2" }
const _hoisted_13 = { class: "row d-flex flex-wrap" }
const _hoisted_14 = /*#__PURE__*/ _withScopeId(() => /*#__PURE__*/_createElementVNode("div", { class: "line-title my-4 my-sm-5" }, [
  /*#__PURE__*/_createTextVNode(" Contact  "),
  /*#__PURE__*/_createElementVNode("div", {
    style: {"white-space":"nowrap"},
    class: "d-flex align-items-center col"
  }, [
    /*#__PURE__*/_createTextVNode(" Information "),
    /*#__PURE__*/_createElementVNode("div", { class: "line-visual" })
  ])
], -1))
const _hoisted_15 = { class: "mimic-input text-truncate col-12 mb-2" }
const _hoisted_16 = { class: "mimic-input text-truncate mb-2" }
const _hoisted_17 = { class: "row d-flex flex-wrap" }
const _hoisted_18 = /*#__PURE__*/ _withScopeId(() => /*#__PURE__*/_createElementVNode("div", { class: "line-title my-4 my-sm-5" }, [
  /*#__PURE__*/_createTextVNode(" Physical   "),
  /*#__PURE__*/_createElementVNode("div", {
    style: {"white-space":"nowrap"},
    class: "d-flex align-items-center col"
  }, [
    /*#__PURE__*/_createTextVNode(" Address "),
    /*#__PURE__*/_createElementVNode("div", { class: "line-visual" })
  ])
], -1))
const _hoisted_19 = { class: "row d-flex flex-wrap" }
const _hoisted_20 = /*#__PURE__*/ _withScopeId(() => /*#__PURE__*/_createElementVNode("div", { class: "line-title my-4 my-sm-5" }, [
  /*#__PURE__*/_createTextVNode(" Update  "),
  /*#__PURE__*/_createElementVNode("div", {
    style: {"white-space":"nowrap"},
    class: "d-flex align-items-center col"
  }, [
    /*#__PURE__*/_createTextVNode(" Password "),
    /*#__PURE__*/_createElementVNode("div", { class: "line-visual" })
  ])
], -1))
const _hoisted_21 = { class: "mt-4 mt-sm-5 mb-3 row flex-wrap gy-2" }
const _hoisted_22 = { class: "col-auto" }
const _hoisted_23 = { class: "col-auto" }

import brand from "@/brand";
import { ElMessage } from "element-plus";
import DialogBox from "@/components/misc/DialogBox.vue"
import type { FormInstance, FormRules } from "element-plus";
import { onBeforeMount, reactive, ref, Ref } from "vue";
import { ValidateFieldsError } from "async-validator";
import { ApiCustomersIdSendOtpPostRequest, CustomersUpdateDto, CustomersUpdateEmailDto, CustomersUpdateMobileNumberDto, MessageType } from "@/api-client";
import { handleInvalidForm } from "@/utilities/api";
import { useUserStore } from "@/stores/user";
import { getCustomer, updateCustomer, sendCustomerOtp, updateCustomerContact } from "@/api/customer";
import { CustomersDto, CustomerType, IDType, Gender } from "@/api-client";
import { copyMatchingProperties, disabledDate } from "@/utilities";

interface CustomerUpdateForm extends CustomersUpdateDto {
  confirmNewPassword: string | null
}

type ContactFormDetails<T> = { [TYPE in MessageType]: { title: string, description: string } };


export default /*#__PURE__*/_defineComponent({
  __name: 'ProfileForm',
  setup(__props) {

let dialogVisible = ref(false);
const userStore = useUserStore();
let item: Ref<CustomersDto> = ref({
  id: "",
  dateTimeStamp: "",
  cancelledDate: "",
  firstName: "",
  middleName: "",
  lastName: "",
  idNumber: "",
  idNationality: "",
  emailAddress: "",
  mobileNumber: "",
  additionalNumber: "",
  status: "",
  statusReason: "",
  dateOfBirth: "",
  suspendedDate: "",
  gender: Gender.Male,
  idType: IDType.Passport,
  customerType: CustomerType.Customer,
  line1: "",
  line2: "",
  line3: "",
  suburb: "",
  city: "",
  province: "",
  country: "",
  customerPaymentMethods: [],
  addressessPostalCode: "",
  usersId: "",
  orders: [],
  accountOtpValidated: true,
});
const profileFormRef = ref<FormInstance>();
const contactFormRef = ref<FormInstance>();
const genderDdl: Gender[] = ["Female", "Male"];
let formGeneralData = ref<CustomerUpdateForm>({
  id: "",
  firstName: "",
  middleName: "",
  lastName: "",
  additionalNumber: "",
  dateOfBirth: "",
  gender: "Female",
  addressess: {
    line1: "",
    line2: "",
    line3: "",
    suburb: "",
    city: "",
    province: "",
    country: "",
    postalCode: "",
  },
  currentPassword: null,
  newPassword: null,
  confirmNewPassword: null
});

let updateContactType: Ref<MessageType> = ref(MessageType.Email);
let otpSent = ref(false);

let formEmailData = ref<{emailAddress: string}>({ 
  emailAddress: "",
});

let formMobileData = ref<{mobileNumber: string}>({ 
  mobileNumber: "",
});

let formOtpData = ref<{otp: string}>({ 
  otp: "",
});

let contactFormDetails: ContactFormDetails<MessageType> = {
  Email: {
    title: 'Update your Email Address',
    description: `Enter your updated email address below to receive a one time password (OTP):`,
  },
  SMS: {
    title: 'Update your Cellphone Number',
    description: `Enter your updated cellphone number below to receive a one time password (OTP):`,
  },
}

const passwordRegex = /^(?=.*[a-z])(?=.*[A-Z])(?=.*[0-9])(?=.*[^a-zA-Z0-9])(.{8,})$/;

const validateCurrentPassword = (rule: any, value: any, callback: any) => {
  if (!value && (formGeneralData.value.newPassword || formGeneralData.value.confirmNewPassword)) {
    callback(new Error("Please enter your current password"));
  } else {
    callback();
  }
};

const validateNewPassword = (rule: any, value: any, callback: any) => {
  if (!value && (formGeneralData.value.currentPassword || formGeneralData.value.confirmNewPassword)) {
    callback(new Error("Please enter your new password"));
  } else if (value && !passwordRegex.test(value)) {
    callback(new Error("Minimum 8 characters: 1 uppercase, 1 lowercase, 1 symbol and 1 number"));
  } else {
    if (!formGeneralData.value.confirmNewPassword) {
      if (!profileFormRef.value) return;
      profileFormRef.value.validateField("confirmNewPassword", () => null);
    }
    callback();
  }
};

const validateConfirmNewPassword = (rule: any, value: any, callback: any) => {
  if (!value && (formGeneralData.value.currentPassword || formGeneralData.value.newPassword)) {
    callback(new Error("Please confirm the new password"));
  } else if (value && value !== formGeneralData.value.newPassword) {
    callback(new Error("The new passwords do not match"));
  } else {
    callback();
  }
};

const generalRules = reactive<FormRules<CustomerUpdateForm>>({
  firstName: [{ required: true, message: "Please enter your first name", trigger: "change" }],
  middleName: [{ message: "Please enter your middle name (optional)", trigger: "change" }],
  lastName: [{ required: true, message: "Please enter your last name", trigger: "change" }],
  additionalNumber: [
    { message: "Please enter an additional number (optional)", trigger: "change" },
    { pattern: /^0\s*\d\s*\d\s*\d\s*\d\s*\d\s*\d\s*\d\s*\d\s*\d\s?$/, message: "Please enter a valid cellphone number (no country code)", trigger: "blur" },
  ],
  dateOfBirth: [{ required: true, message: "Please enter your date of birth", trigger: "change" }],
  gender: [{ required: true, message: "Please enter your gender", trigger: "change" }],
  currentPassword: [{ validator: validateCurrentPassword, trigger: "change" }],
  newPassword: [{ validator: validateNewPassword, trigger: "change" }],
  confirmNewPassword: [{ validator: validateConfirmNewPassword, trigger: "change" }],
  "addressess.line1": [{ required: true, message: "Please enter address line 1", trigger: "change" }],
  "addressess.line2": [{ message: "Please enter address line 2", trigger: "change" }],
  "addressess.line3": [{  message: "Please enter address line 3", trigger: "change" }],
  "addressess.suburb": [{ required: true, message: "Please enter address suburb", trigger: "change" }],
  "addressess.city": [{ required: true, message: "Please enter address city", trigger: "change" }],
  "addressess.province": [{ message: "Please enter address province", trigger: "change" }],
  "addressess.country": [{ required: true, message: "Please enter address country", trigger: "change" }],
  "addressess.postalCode": [{ required: true, message: "Please enter address postal code", trigger: "change" }],
});

const otpRules = reactive<FormRules<{ otp: string }>>({
  otp: [{ required: true, message: "Please enter the OTP", trigger: "change" }],
})

const emailRules = reactive<FormRules<{ emailAddress: string }>>({
  emailAddress: [{ required: true, type: 'email', message: "Please enter a valid updated email", trigger: "change" }],
})

const mobileRules = reactive<FormRules<{ mobileNumber: string }>>({
  mobileNumber: [
    { required: true, message: "Please enter updated cellphone number", trigger: "change" },
    { pattern: /^0\s*\d\s*\d\s*\d\s*\d\s*\d\s*\d\s*\d\s*\d\s*\d\s?$/, message: "Please enter a valid cellphone number (no country code)", trigger: "blur" },
  ],
  
})

const submitForm = async (formEl: FormInstance | undefined) => {
  if (!formEl) return;
  await formEl.validate(async (valid, fields) => {
    if (valid) {
      updateCustomer(formGeneralData.value).then(async () => {
        await loadInitialData();
      })
      console.log("valid");
      // handle valid
    } else {
      handleInvalidForm(fields as ValidateFieldsError);
    }
  });
};

const submitContactForm  = async (formEl: FormInstance | undefined) => {
  if (!formEl) return;
  await formEl.validate(async (valid, fields) => {
    if(valid) {
      if(otpSent.value) {
      // Validate OTP
        let payload;
        switch(updateContactType.value) {
          case "Email": {
            payload = {
              id: userStore.id,
              emailAddress: formEmailData.value.emailAddress,
              otp: formOtpData.value.otp
            } as CustomersUpdateEmailDto; 
            break;
          }

          case "SMS": {
            payload = {
              id: userStore.id,
              mobileNumber: formMobileData.value.mobileNumber,
              otp: formOtpData.value.otp
            } as CustomersUpdateMobileNumberDto;
            break;
          }

          default:
            break;
        }

        if(payload) {
          updateCustomerContact(updateContactType.value, payload).then(async () => {
            await loadInitialData(false);
          }).catch(() => closeUpdateContactDialog())
        }
      } else {
        // Send OTP
        if(updateContactType.value === "SMS") {
          formMobileData.value.mobileNumber = formMobileData.value.mobileNumber.replaceAll(' ', '');
        }
        
        sendOTP()
      }
    } else {
      handleInvalidForm(fields as ValidateFieldsError);
    }
  });
};

function sendOTP() {
  const payload: ApiCustomersIdSendOtpPostRequest = {
    customersId: userStore.id,
    messageType: updateContactType.value,
    contact: updateContactType.value === "Email" ? formEmailData.value.emailAddress : formMobileData.value.mobileNumber
  }

  sendCustomerOtp(payload).then((res) => {
    otpSent.value = true;
  }).catch(() => closeUpdateContactDialog())
}

onBeforeMount(async () => {
  await loadInitialData();
});

function updateViaOtp(type: MessageType) {
  updateContactType.value = type;
  dialogVisible.value = true;
}

function closeUpdateContactDialog() {
  formEmailData.value = { 
    emailAddress: "",
  };
  formMobileData.value = { 
    mobileNumber: "",
  };
  formOtpData.value = {
    otp: ""
  }

  otpSent.value = false;
  dialogVisible.value = false;
}

async function loadInitialData(updateForm = true) {
  if (userStore.id) {
    await getCustomer(userStore.id).then((res) => {
      item.value = res;

      if(updateForm) {
        formGeneralData.value = {
          id: res.id,
          firstName: res.firstName,
          middleName: res.middleName,
          lastName: res.lastName,
          additionalNumber: res.additionalNumber,
          dateOfBirth: res.dateOfBirth,
          gender: res.gender,
          addressess: {
            line1: res.address.line1,
            line2: res.address.line2,
            line3: res.address.line3,
            suburb: res.address.suburb,
            city: res.address.city,
            province: res.address.province,
            country: res.address.country,
            postalCode: res.address.postalCode,
          },
          currentPassword: null,
          newPassword: null,
          confirmNewPassword: null
        }
      }

      closeUpdateContactDialog()
    });
  }
}

return (_ctx: any,_cache: any) => {
  const _component_el_input = _resolveComponent("el-input")!
  const _component_el_form_item = _resolveComponent("el-form-item")!
  const _component_el_form = _resolveComponent("el-form")!
  const _component_el_date_picker = _resolveComponent("el-date-picker")!
  const _component_el_option = _resolveComponent("el-option")!
  const _component_el_select = _resolveComponent("el-select")!
  const _component_font_awesome_icon = _resolveComponent("font-awesome-icon")!
  const _component_el_tooltip = _resolveComponent("el-tooltip")!
  const _component_router_link = _resolveComponent("router-link")!

  return (_openBlock(), _createElementBlock(_Fragment, null, [
    _createVNode(DialogBox, {
      title: _unref(contactFormDetails)[_unref(updateContactType)].title,
      confirmVisible: false,
      cancelVisible: false,
      dialogVisible: _unref(dialogVisible),
      onClose: closeUpdateContactDialog
    }, {
      default: _withCtx(() => [
        (_openBlock(), _createBlock(_component_el_form, {
          ref_key: "contactFormRef",
          ref: contactFormRef,
          "validate-on-rule-change": false,
          key: _unref(otpSent) ? 'OTP' : _unref(updateContactType),
          model: _unref(otpSent) ? _unref(formOtpData) : _unref(updateContactType) === 'Email' ? _unref(formEmailData) : _unref(formMobileData),
          rules: _unref(otpSent) ? otpRules : _unref(updateContactType) === 'Email' ? emailRules : mobileRules,
          size: "large",
          "label-position": "top",
          "require-asterisk-position": "right"
        }, {
          default: _withCtx(() => [
            _createElementVNode("div", null, [
              (!_unref(otpSent))
                ? (_openBlock(), _createElementBlock("span", _hoisted_1, [
                    _createElementVNode("div", _hoisted_2, _toDisplayString(_unref(contactFormDetails)[_unref(updateContactType)].description), 1),
                    (_unref(updateContactType) === 'SMS')
                      ? (_openBlock(), _createBlock(_component_el_form_item, {
                          key: 0,
                          class: "col-12 col-xl-10 col-xxl-8 pb-2 mb-3 mb-md-4",
                          label: "Updated Cellphone Number",
                          prop: "mobileNumber"
                        }, {
                          default: _withCtx(() => [
                            _createVNode(_component_el_input, {
                              name: "mobileNumber",
                              type: "search",
                              modelValue: _unref(formMobileData).mobileNumber,
                              "onUpdate:modelValue": _cache[0] || (_cache[0] = ($event: any) => ((_unref(formMobileData).mobileNumber) = $event)),
                              placeholder: "Enter your updated cellphone number (*)"
                            }, null, 8, ["modelValue"])
                          ]),
                          _: 1
                        }))
                      : _createCommentVNode("", true),
                    (_unref(updateContactType) === 'Email')
                      ? (_openBlock(), _createBlock(_component_el_form_item, {
                          key: 1,
                          class: "col-12 col-xl-10 col-xxl-8 pb-2 mb-3 mb-md-4",
                          label: "Updated Email",
                          prop: "emailAddress"
                        }, {
                          default: _withCtx(() => [
                            _createVNode(_component_el_input, {
                              name: "emailAddress",
                              type: "search",
                              modelValue: _unref(formEmailData).emailAddress,
                              "onUpdate:modelValue": _cache[1] || (_cache[1] = ($event: any) => ((_unref(formEmailData).emailAddress) = $event)),
                              placeholder: "Enter your updated email address (*)"
                            }, null, 8, ["modelValue"])
                          ]),
                          _: 1
                        }))
                      : _createCommentVNode("", true)
                  ]))
                : (_openBlock(), _createElementBlock("span", _hoisted_3, [
                    _createElementVNode("div", _hoisted_4, "An OTP has been send to " + _toDisplayString(_unref(updateContactType) === 'Email' ? _unref(formEmailData).emailAddress : _unref(formMobileData).mobileNumber) + ". Enter the OTP below:", 1),
                    _createVNode(_component_el_form_item, {
                      class: "col-12 col-xl-10 col-xxl-8 pb-2 mb-3 mb-md-4",
                      label: "OTP",
                      prop: "otp"
                    }, {
                      default: _withCtx(() => [
                        _createVNode(_component_el_input, {
                          name: "otp",
                          type: "search",
                          modelValue: _unref(formOtpData).otp,
                          "onUpdate:modelValue": _cache[2] || (_cache[2] = ($event: any) => ((_unref(formOtpData).otp) = $event)),
                          placeholder: "Enter your OTP (*)"
                        }, null, 8, ["modelValue"])
                      ]),
                      _: 1
                    })
                  ]))
            ]),
            _createElementVNode("div", _hoisted_5, [
              _createElementVNode("div", _hoisted_6, [
                _createElementVNode("button", {
                  type: "button",
                  class: "btn btn-primary",
                  onClick: _cache[3] || (_cache[3] = ($event: any) => (submitContactForm(contactFormRef.value)))
                }, _toDisplayString(!_unref(otpSent) ? 'Send OTP' : _unref(updateContactType) == 'Email' ? 'Update Email' : 'Update Cellphone Number'), 1)
              ]),
              _createElementVNode("div", { class: "col-auto" }, [
                _createElementVNode("div", {
                  onClick: closeUpdateContactDialog,
                  class: "btn btn-outline-primary"
                }, "Cancel")
              ])
            ])
          ]),
          _: 1
        }, 8, ["model", "rules"]))
      ]),
      _: 1
    }, 8, ["title", "dialogVisible"]),
    (!_unref(brand).provider)
      ? (_openBlock(), _createElementBlock("h1", _hoisted_7, "My Profile"))
      : _createCommentVNode("", true),
    _createElementVNode("div", _hoisted_8, [
      _createVNode(_component_el_form, {
        ref_key: "profileFormRef",
        ref: profileFormRef,
        model: _unref(formGeneralData),
        rules: generalRules,
        size: "large",
        "label-position": "top",
        "require-asterisk-position": "right"
      }, {
        default: _withCtx(() => [
          _createElementVNode("div", _hoisted_9, [
            _hoisted_10,
            _createVNode(_component_el_form_item, {
              class: "col-12 col-md-6 pb-2 mb-3 mb-md-4",
              label: "First Name",
              prop: "firstName"
            }, {
              default: _withCtx(() => [
                _createVNode(_component_el_input, {
                  modelValue: _unref(formGeneralData).firstName,
                  "onUpdate:modelValue": _cache[4] || (_cache[4] = ($event: any) => ((_unref(formGeneralData).firstName) = $event)),
                  name: "firstName",
                  placeholder: "Enter your first name (*)"
                }, null, 8, ["modelValue"])
              ]),
              _: 1
            }),
            _createVNode(_component_el_form_item, {
              class: "col-12 col-md-6 pb-2 mb-3 mb-md-4",
              label: "Middle Name",
              prop: "middleName"
            }, {
              default: _withCtx(() => [
                _createVNode(_component_el_input, {
                  modelValue: _unref(formGeneralData).middleName,
                  "onUpdate:modelValue": _cache[5] || (_cache[5] = ($event: any) => ((_unref(formGeneralData).middleName) = $event)),
                  name: "middleName",
                  placeholder: "Enter your middle name (optional)"
                }, null, 8, ["modelValue"])
              ]),
              _: 1
            }),
            _createVNode(_component_el_form_item, {
              class: "col-12 col-md-6 pb-2 mb-3 mb-md-4",
              label: "Last Name",
              prop: "lastName"
            }, {
              default: _withCtx(() => [
                _createVNode(_component_el_input, {
                  modelValue: _unref(formGeneralData).lastName,
                  "onUpdate:modelValue": _cache[6] || (_cache[6] = ($event: any) => ((_unref(formGeneralData).lastName) = $event)),
                  name: "lastName",
                  placeholder: "Enter your last name (*)"
                }, null, 8, ["modelValue"])
              ]),
              _: 1
            }),
            _createVNode(_component_el_form_item, {
              class: "col-12 col-md-6 pb-2 mb-3 mb-md-4",
              label: "Date of Birth",
              prop: "dateOfBirth"
            }, {
              default: _withCtx(() => [
                _createVNode(_component_el_date_picker, {
                  format: "DD/MM/YYYY",
                  "picker-options": { firstDayOfWeek: 1 },
                  clearable: "",
                  modelValue: _unref(formGeneralData).dateOfBirth,
                  "onUpdate:modelValue": _cache[7] || (_cache[7] = ($event: any) => ((_unref(formGeneralData).dateOfBirth) = $event)),
                  name: "dateOfBirth",
                  type: "date",
                  placeholder: "Enter your date of birth (*)",
                  "disabled-date": _unref(disabledDate)
                }, null, 8, ["modelValue", "disabled-date"])
              ]),
              _: 1
            }),
            _createVNode(_component_el_form_item, {
              class: "col-12 col-md-6 pb-2 mb-3 mb-md-4",
              label: "Gender",
              prop: "gender"
            }, {
              default: _withCtx(() => [
                _createVNode(_component_el_select, {
                  name: "gender",
                  modelValue: _unref(formGeneralData).gender,
                  "onUpdate:modelValue": _cache[8] || (_cache[8] = ($event: any) => ((_unref(formGeneralData).gender) = $event)),
                  "default-first-option": "",
                  placeholder: "Select your gender (*)"
                }, {
                  default: _withCtx(() => [
                    (_openBlock(), _createElementBlock(_Fragment, null, _renderList(genderDdl, (item) => {
                      return _createVNode(_component_el_option, {
                        label: item,
                        value: item,
                        key: item
                      }, null, 8, ["label", "value"])
                    }), 64))
                  ]),
                  _: 1
                }, 8, ["modelValue"])
              ]),
              _: 1
            }),
            _createVNode(_component_el_form_item, {
              class: "col-12 col-md-6 pb-2 mb-3 mb-md-4 asterix",
              label: "ID Type / Nationality"
            }, {
              default: _withCtx(() => [
                _createElementVNode("div", _hoisted_11, _toDisplayString(_unref(item).idType == 'IDNumber' ? 'National ID' : 'Passport') + " - " + _toDisplayString(_unref(item).idNationality), 1)
              ]),
              _: 1
            }),
            _createVNode(_component_el_form_item, {
              class: "col-12 col-md-6 pb-2 mb-3 mb-md-4 asterix",
              label: `${_unref(item).idType == 'IDNumber' ? 'ID' : 'Passport'} Number`
            }, {
              default: _withCtx(() => [
                _createElementVNode("div", _hoisted_12, [
                  _createVNode(_component_el_tooltip, {
                    "hide-after": 1000,
                    effect: "light",
                    placement: "bottom",
                    content: `To update your ${_unref(item).idType == 'IDNumber' ? 'ID' : 'passport'} number please contact Helpdesk.`
                  }, {
                    default: _withCtx(() => [
                      _createElementVNode("span", null, [
                        _createVNode(_component_font_awesome_icon, {
                          class: "fs-6 text-secondary me-2",
                          icon: "fa-solid fa-circle-info"
                        }),
                        _createTextVNode(" " + _toDisplayString(_unref(item).idNumber), 1)
                      ])
                    ]),
                    _: 1
                  }, 8, ["content"])
                ])
              ]),
              _: 1
            }, 8, ["label"])
          ]),
          _createElementVNode("div", _hoisted_13, [
            _hoisted_14,
            _createVNode(_component_el_form_item, {
              class: "col-12 col-md-6 pb-2 mb-3 mb-md-4 asterix",
              label: "Email"
            }, {
              default: _withCtx(() => [
                _createElementVNode("div", _hoisted_15, [
                  _createVNode(_component_font_awesome_icon, {
                    onClick: _cache[9] || (_cache[9] = ($event: any) => (updateViaOtp('Email'))),
                    class: "pointer fs-6 text-primary me-2",
                    icon: "fa-solid fa-pen-to-square"
                  }),
                  _createTextVNode(_toDisplayString(_unref(item).emailAddress), 1)
                ])
              ]),
              _: 1
            }),
            _createVNode(_component_el_form_item, {
              class: "col-12 col-md-6 pb-2 mb-3 mb-md-4 asterix",
              label: "Cellphone Number"
            }, {
              default: _withCtx(() => [
                _createElementVNode("div", _hoisted_16, [
                  _createVNode(_component_font_awesome_icon, {
                    onClick: _cache[10] || (_cache[10] = ($event: any) => (updateViaOtp('SMS'))),
                    class: "pointer fs-6 text-primary me-2",
                    icon: "fa-solid fa-pen-to-square"
                  }),
                  _createTextVNode(_toDisplayString(_unref(item).mobileNumber), 1)
                ])
              ]),
              _: 1
            }),
            _createVNode(_component_el_form_item, {
              class: "col-12 col-md-6 pb-2 mb-3 mb-md-4",
              label: "Additional Number",
              prop: "additionalNumber"
            }, {
              default: _withCtx(() => [
                _createVNode(_component_el_input, {
                  name: "additionalNumber",
                  modelValue: _unref(formGeneralData).additionalNumber,
                  "onUpdate:modelValue": _cache[11] || (_cache[11] = ($event: any) => ((_unref(formGeneralData).additionalNumber) = $event)),
                  placeholder: "Enter an additional number (optional)"
                }, null, 8, ["modelValue"])
              ]),
              _: 1
            })
          ]),
          _createElementVNode("div", _hoisted_17, [
            _hoisted_18,
            _createVNode(_component_el_form_item, {
              class: "col-12 col-md-6 pb-2 mb-3 mb-md-4",
              label: "Line 1",
              prop: "addressess.line1"
            }, {
              default: _withCtx(() => [
                _createVNode(_component_el_input, {
                  modelValue: _unref(formGeneralData).addressess.line1,
                  "onUpdate:modelValue": _cache[12] || (_cache[12] = ($event: any) => ((_unref(formGeneralData).addressess.line1) = $event)),
                  name: "addressess.line1",
                  placeholder: "Enter address line 1 (*)"
                }, null, 8, ["modelValue"])
              ]),
              _: 1
            }),
            _createVNode(_component_el_form_item, {
              class: "col-12 col-md-6 pb-2 mb-3 mb-md-4",
              label: "Line 2",
              prop: "addressess.line2"
            }, {
              default: _withCtx(() => [
                _createVNode(_component_el_input, {
                  modelValue: _unref(formGeneralData).addressess.line2,
                  "onUpdate:modelValue": _cache[13] || (_cache[13] = ($event: any) => ((_unref(formGeneralData).addressess.line2) = $event)),
                  name: "addressess.line2",
                  placeholder: "Enter address line 2 (optional)"
                }, null, 8, ["modelValue"])
              ]),
              _: 1
            }),
            _createVNode(_component_el_form_item, {
              class: "col-12 col-md-6 pb-2 mb-3 mb-md-4",
              label: "Line 3",
              prop: "addressess.line3"
            }, {
              default: _withCtx(() => [
                _createVNode(_component_el_input, {
                  modelValue: _unref(formGeneralData).addressess.line3,
                  "onUpdate:modelValue": _cache[14] || (_cache[14] = ($event: any) => ((_unref(formGeneralData).addressess.line3) = $event)),
                  name: "addressess.line3",
                  placeholder: "Enter address line 3 (optional)"
                }, null, 8, ["modelValue"])
              ]),
              _: 1
            }),
            _createVNode(_component_el_form_item, {
              class: "col-12 col-md-6 pb-2 mb-3 mb-md-4",
              label: "Suburb",
              prop: "addressess.suburb"
            }, {
              default: _withCtx(() => [
                _createVNode(_component_el_input, {
                  modelValue: _unref(formGeneralData).addressess.suburb,
                  "onUpdate:modelValue": _cache[15] || (_cache[15] = ($event: any) => ((_unref(formGeneralData).addressess.suburb) = $event)),
                  name: "addressess.suburb",
                  placeholder: "Enter address suburb (*)"
                }, null, 8, ["modelValue"])
              ]),
              _: 1
            }),
            _createVNode(_component_el_form_item, {
              class: "col-12 col-md-6 pb-2 mb-3 mb-md-4",
              label: "City",
              prop: "addressess.city"
            }, {
              default: _withCtx(() => [
                _createVNode(_component_el_input, {
                  modelValue: _unref(formGeneralData).addressess.city,
                  "onUpdate:modelValue": _cache[16] || (_cache[16] = ($event: any) => ((_unref(formGeneralData).addressess.city) = $event)),
                  name: "addressess.city",
                  placeholder: "Enter city (*)"
                }, null, 8, ["modelValue"])
              ]),
              _: 1
            }),
            _createVNode(_component_el_form_item, {
              class: "col-12 col-md-6 pb-2 mb-3 mb-md-4",
              label: "Province",
              prop: "addressess.province"
            }, {
              default: _withCtx(() => [
                _createVNode(_component_el_input, {
                  modelValue: _unref(formGeneralData).addressess.province,
                  "onUpdate:modelValue": _cache[17] || (_cache[17] = ($event: any) => ((_unref(formGeneralData).addressess.province) = $event)),
                  name: "addressess.province",
                  placeholder: "Enter address province (optional)"
                }, null, 8, ["modelValue"])
              ]),
              _: 1
            }),
            _createVNode(_component_el_form_item, {
              class: "col-12 col-md-6 pb-2 mb-3 mb-md-4",
              label: "Country",
              prop: "addressess.country"
            }, {
              default: _withCtx(() => [
                _createVNode(_component_el_input, {
                  modelValue: _unref(formGeneralData).addressess.country,
                  "onUpdate:modelValue": _cache[18] || (_cache[18] = ($event: any) => ((_unref(formGeneralData).addressess.country) = $event)),
                  name: "addressess.country",
                  placeholder: "Enter country (*)"
                }, null, 8, ["modelValue"])
              ]),
              _: 1
            }),
            _createVNode(_component_el_form_item, {
              class: "col-12 col-md-6 pb-2 mb-3 mb-md-4",
              label: "Postal Code",
              prop: "addressess.postalCode"
            }, {
              default: _withCtx(() => [
                _createVNode(_component_el_input, {
                  modelValue: _unref(formGeneralData).addressess.postalCode,
                  "onUpdate:modelValue": _cache[19] || (_cache[19] = ($event: any) => ((_unref(formGeneralData).addressess.postalCode) = $event)),
                  name: "addressess.postalCode",
                  placeholder: "Enter postalCode (*)"
                }, null, 8, ["modelValue"])
              ]),
              _: 1
            })
          ]),
          _createElementVNode("div", _hoisted_19, [
            _hoisted_20,
            _createVNode(_component_el_form_item, {
              class: "col-12 col-md-6 pb-2 mb-3 mb-md-4",
              label: "Current Password",
              prop: "currentPassword"
            }, {
              default: _withCtx(() => [
                _createVNode(_component_el_input, {
                  modelValue: _unref(formGeneralData).currentPassword,
                  "onUpdate:modelValue": _cache[20] || (_cache[20] = ($event: any) => ((_unref(formGeneralData).currentPassword) = $event)),
                  autocomplete: "new-password",
                  name: "currentPassword",
                  type: "password",
                  placeholder: "Enter your current password",
                  "show-password": ""
                }, null, 8, ["modelValue"])
              ]),
              _: 1
            }),
            _createVNode(_component_el_form_item, {
              class: "col-12 col-md-6 pb-2 mb-3 mb-md-4",
              label: "New Password",
              prop: "newPassword"
            }, {
              default: _withCtx(() => [
                _createVNode(_component_el_input, {
                  modelValue: _unref(formGeneralData).newPassword,
                  "onUpdate:modelValue": _cache[21] || (_cache[21] = ($event: any) => ((_unref(formGeneralData).newPassword) = $event)),
                  autocomplete: "new-password",
                  name: "newPassword",
                  type: "password",
                  placeholder: "Enter your new password (*)",
                  "show-password": ""
                }, null, 8, ["modelValue"])
              ]),
              _: 1
            }),
            _createVNode(_component_el_form_item, {
              class: "col-12 col-md-6 pb-2 mb-3 mb-md-4",
              label: "Confirm New Password",
              prop: "confirmNewPassword"
            }, {
              default: _withCtx(() => [
                _createVNode(_component_el_input, {
                  modelValue: _unref(formGeneralData).confirmNewPassword,
                  "onUpdate:modelValue": _cache[22] || (_cache[22] = ($event: any) => ((_unref(formGeneralData).confirmNewPassword) = $event)),
                  autocomplete: "new-password",
                  name: "confirmNewPassword",
                  type: "password",
                  placeholder: "Confirm your new password (*)",
                  "show-password": ""
                }, null, 8, ["modelValue"])
              ]),
              _: 1
            })
          ]),
          _createElementVNode("div", _hoisted_21, [
            _createElementVNode("div", _hoisted_22, [
              _createElementVNode("button", {
                type: "button",
                class: "btn btn-primary",
                onClick: _cache[23] || (_cache[23] = ($event: any) => (submitForm(profileFormRef.value)))
              }, "Update")
            ]),
            _createElementVNode("div", _hoisted_23, [
              _createVNode(_component_router_link, {
                to: { name: 'Dashboard' },
                class: "btn btn-outline-primary"
              }, {
                default: _withCtx(() => [
                  _createTextVNode("Back")
                ]),
                _: 1
              })
            ])
          ])
        ]),
        _: 1
      }, 8, ["model", "rules"])
    ])
  ], 64))
}
}

})